import FirstToContact from '@forwardflow/components/Campaign/FirstToContact'

const WaitingTimePage = () => {
   return (
      <>
         <FirstToContact />
      </>
   )
}

export default WaitingTimePage
